// 找工作页面接口
import {
  get,
  post
} from '../utils/request.js'

//获取初始数据
export const apiGetEstateHome = function(data) {
  return get('build/getEstateHome', data);
}

//获取筛选列表数据
export const apiGetList = function() {
  return get('newHouse/getList');
}

//获取详情
export const apiGetDetail = function(data) {

  return get('newHouse/getEstateList', data);
}

//换一换
export const apiChangeOther = function(data) {
  return get('recru/change', data);
}

//根据城市id获取对应区(一期版本接口)
export const apiGetArea = function(data) {
  return get('recru/getCounty', data);
}

//根据城市id获取对应区(二期版本接口)
export const apiGetCity = function(data) {
  return get('build/getEstateAlbum', data);
}


//楼盘相册
export const getEstateAlbum = function(data) {
  return get('build/getAlbumList', data);
}

//楼盘详情
export const apiGetEstateDetail = function(data) {
  return get('build/getEstateDetail', data);
}


//户型广告
export const getEstateHouse = function(data) {
  return get('build/getEstateHouse', data);
}

//户型详情
export const getHouseList = function(data) {
  return get('build/getHouseList', data);
}


//户型详情界面
export const getHouseDetail = function(data) {
  return get('build/getHouseDetail', data);
}



//楼盘动态界面
export const apiGetEstateArticle = function(data) {
  return get('build/getEstateArticle', data);
}

//楼盘动态界面--列表
export const apiGetEstateArticleList = function(data) {
  return get('build/getArticleList', data);
}


//获取地图周围经纬度
export const apiGetLocation = function(data) {
  return get('/index/getMap', data);
}



// WEBPACK FOOTER //
// ./src/api/job.js